module.exports = __webpack_public_path__ + "img/property_responsive.cef38a07.png";